export default function cadastros(podeAcessar) {
  return [
    {
      name: 'Inicio',
      icon: 'fa fa-th-large fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: true,
      link: '/app/cad/inicio',
    },
    {
      name: 'Unidades / Empresas',
      icon: 'fa fa-building fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('cad_multi_empresa'),
      link: '/app/cad/multi-empresa',
    },
    {
      name: 'Carteiras / Credores',
      icon: 'fa fa-university fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('cad_credor_v'),
      link: '/app/cad/credores',
    },
    {
      name: 'Devedores',
      icon: 'fa fa-user fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('cad_devedor_v'),
      link: '/app/cad/devedores',
    },
    {
      name: 'Grupos de Credores',
      icon: 'fa fa-users fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('cad_credor_grupo'),
      link: '/app/cad/grupo-credores',
    },
    {
      name: 'Colaboradores',
      icon: 'fa fa-user-circle-o fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('cad_colaborador_v'),
      link: '/app/cad/colaboradores',
    },
    {
      name: 'Equipes',
      icon: 'fa fa-users fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('cad_colaborador_grupo'),
      link: '/app/cad/equipes',
    },
    {
      name: 'Fornecedores',
      icon: 'fa fa-truck fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('cad_fornecedor_v'),
      link: '/app/cad/fornecedores',
    },
    {
      name: 'Tabelas - Cadastro',
      ativo:
        podeAcessar('tab_categoria_cred') ||
        podeAcessar('tab_segmento_cred') ||
        podeAcessar('tab_segmento_dev') ||
        podeAcessar('tab_tags_marcacoes') ||
        podeAcessar('tab_especie_titulo'),
      icon: 'fa fa-folder-open fa-fw',
      iconSize: '1.2em',
      type: 'collapse',
      children: [
        {
          name: 'Marcações de Processos',
          type: 'item',
          ativo: podeAcessar('tab_tags_marcacoes'),
          link: '/app/cad/tabelas/marcacoes-de-processo',
        },
        {
          name: 'Espécie de Título',
          type: 'item',
          ativo: podeAcessar('tab_especie_titulo'),
          link: '/app/cad/tabelas/especie-titulo',
        },
        {
          name: 'Categorias de Credores',
          type: 'item',
          ativo: podeAcessar('tab_categoria_cred'),
          link: '/app/cad/tabelas/categorias-credor',
        },
        {
          name: 'Segmentos de Credores',
          type: 'item',
          ativo: podeAcessar('tab_segmento_cred'),
          link: '/app/cad/tabelas/segmento-credor',
        },
        {
          name: 'Segmentos de Devedores',
          type: 'item',
          ativo: podeAcessar('tab_segmento_dev'),
          link: '/app/cad/tabelas/segmento-devedor',
        },
      ],
    },
    {
      name: 'Tabelas - Financeiro',
      ativo:
        podeAcessar('tab_bancos') ||
        podeAcessar('tab_contas') ||
        podeAcessar('tab_custo') ||
        podeAcessar('tab_plano_conta') ||
        podeAcessar('tab_forma_pagto') ||
        podeAcessar('tab_empresas'),
      icon: 'fa fa-folder-open fa-fw',
      iconSize: '1.2em',
      type: 'collapse',
      children: [
        {
          name: 'Bancos',
          type: 'item',
          ativo: podeAcessar('tab_bancos'),
          link: '/app/cad/tabelas/bancos',
        },
        {
          name: 'Contas Bancárias',
          type: 'item',
          ativo: podeAcessar('tab_contas'),
          link: '/app/cad/tabelas/contas-bancarias',
        },
        {
          name: 'Centro de Custo',
          type: 'item',
          ativo: podeAcessar('tab_custo'),
          link: '/app/cad/tabelas/centro-custo',
        },
        {
          name: 'Plano de Conta',
          type: 'item',
          ativo: podeAcessar('tab_plano_conta'),
          link: '/app/cad/tabelas/plano-conta',
        },
        {
          name: 'Formas de Pagamento',
          type: 'item',
          ativo: podeAcessar('tab_forma_pagto'),
          link: '/app/cad/tabelas/forma-pagto',
        },
        {
          name: 'Empresas',
          type: 'item',
          ativo: podeAcessar('tab_empresas'),
          link: '/app/cad/tabelas/empresa',
        },
      ],
    },
    {
      name: 'Tab - Parametrizações',
      ativo:
        podeAcessar('tab_param_cob') ||
        podeAcessar('tab_param_car') ||
        podeAcessar('tab_camp_desc') ||
        podeAcessar('tab_modal_contr') ||
        podeAcessar('tab_comissao_escalonada') ||
        podeAcessar('tab_modelos_pc'),
      icon: 'fa fa-folder-open fa-fw',
      iconSize: '1.2em',
      type: 'collapse',
      children: [
        {
          name: 'Param. de Cobrança',
          type: 'item',
          ativo: podeAcessar('tab_param_cob'),
          link: '/app/cad/tabelas/parametros-atraso',
        },
        {
          name: 'Param. de Carteira',
          type: 'item',
          ativo: podeAcessar('tab_param_car'),
          link: '/app/cad/tabelas/parametros-carteira',
        },
        {
          name: 'Campanhas de Desconto',
          type: 'item',
          ativo: podeAcessar('tab_camp_desc'),
          link: '/app/cad/tabelas/campanhas-desconto',
        },
        {
          name: 'Modalidades de Contrato',
          type: 'item',
          ativo: podeAcessar('tab_modal_contr'),
          link: '/app/cad/tabelas/modalidade-contrato',
        },
        {
          name: 'Comissão Escalonada',
          type: 'item',
          ativo: podeAcessar('tab_comissao_escalonada'),
          link: '/app/cad/tabelas/comissao-escalonada',
        },
        {
          name: 'Modelos de Prestação',
          type: 'item',
          ativo: podeAcessar('tab_modelos_pc'),
          link: '/app/cad/tabelas/modelos-prestacao',
        },
      ],
    },
    {
      name: 'Tabelas - Discador',
      ativo: podeAcessar('tabelas_discador'),
      icon: 'fa fa-folder-open fa-fw',
      iconSize: '1.2em',
      type: 'collapse',
      children: [
        {
          name: 'Qualificação de Telefones',
          type: 'item',
          ativo: podeAcessar('tabelas_discador'),
          link: '/app/cad/tabelas/qualificacao-telefones',
        },
        {
          name: 'Qualificação de Chamadas (Manual)',
          type: 'item',
          ativo: podeAcessar('tabelas_discador'),
          link: '/app/cad/tabelas/qualificacao-chamadas',
        },
        {
          name: 'Qualificação de Chamadas (Retorno Discador Automático)',
          type: 'item',
          ativo: podeAcessar('tabelas_discador'),
          link: '/app/cad/tabelas/qualificacao-chamadas-discador',
        },
        {
          name: 'Motivos de Pausa',
          type: 'item',
          ativo: podeAcessar('tabelas_discador'),
          link: '/app/cad/tabelas/motivo-pausa',
        },
      ],
    },
    {
      name: 'Tabelas - Diversos',
      ativo:
        podeAcessar('tab_categoria_instrucao') ||
        podeAcessar('tab_motivo_inadimplencia') ||
        podeAcessar('tab_comissao_periodo') ||
        podeAcessar('tab_fases') ||
        podeAcessar('tab_classifica_acordo') ||
        podeAcessar('tab_inclusao_negativacao') ||
        podeAcessar('tab_retirada_negativacao'),
      icon: 'fa fa-folder-open fa-fw',
      iconSize: '1.2em',
      type: 'collapse',
      children: [
        {
          name: 'Categorias de Instrução',
          type: 'item',
          ativo: podeAcessar('tab_categoria_instrucao') == true,
          link: '/app/cad/tabelas/categoria-instrucao',
        },
        {
          name: 'Comissão por Período',
          type: 'item',
          ativo: podeAcessar('tab_comissao_periodo') == true,
          link: '/app/cad/tabelas/comissao-periodo',
        },
        {
          name: 'Fases de Processo',
          type: 'item',
          ativo: podeAcessar('tab_fases'),
          link: '/app/cad/tabelas/fases-processo',
        },
        {
          name: 'Motivos de Inadimplência',
          type: 'item',
          ativo: podeAcessar('tab_motivo_inadimplencia'),
          link: '/app/cad/tabelas/motivo-inadimplencia',
        },
        {
          name: 'Classificação de Acordos',
          type: 'item',
          ativo: podeAcessar('tab_classifica_acordo'),
          link: '/app/cad/tabelas/classificacao-acordos',
        },
        {
          name: 'Negativação - Naturezas de Inclusão',
          type: 'item',
          ativo: podeAcessar('tab_inclusao_negativacao'),
          link: '/app/cad/tabelas/negativacao-natureza-inclusao',
        },
        {
          name: 'Negativação - Motivos de Retirada',
          type: 'item',
          ativo: podeAcessar('tab_retirada_negativacao'),
          link: '/app/cad/tabelas/negativacao-motivos-retirada',
        },
      ],
    },
  ];
}
